const Config = {
  LEARN_MORE_URL: 'http://www.storygenie.com.au/learning-guide',
  GENERATE_MORE_STORIES_FOR_ENUM: '(please provide full project work breakdown structure)'
};

export default Config;
